var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.96863L5.40811 10.7746L6.17416 11.3372L6.7749 10.6007L6 9.96863ZM2.59189 6.22523L1.78588 5.63334L0.60209 7.24537L1.40811 7.83727L2.59189 6.22523ZM13.2749 2.63208L13.907 1.85719L12.3572 0.593016L11.7251 1.36792L13.2749 2.63208ZM6.59189 9.16261L2.59189 6.22523L1.40811 7.83727L5.40811 10.7746L6.59189 9.16261ZM6.7749 10.6007L13.2749 2.63208L11.7251 1.36792L5.2251 9.33654L6.7749 10.6007Z",
    fill: "#094A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.93228488fffb80bd9b5d564d24b3298a.svg";
export { ForwardRef as ReactComponent };